
/*------------------------list-reception-unexpectedly-------------------------*/
import {
  ReceptionUnexpectedly,
  SearchReception
} from './list-reception-unexpectedly';
export {
  ReceptionUnexpectedly,
  SearchReception
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-unexpectedly/index.js